<p-button
  [label]="label"
  [severity]="severity"
  variant="outlined"
  [class.centered-text]="centeredText"
  [disabled]="disabled"
  [type]="type"
  [icon]="icon"
  [styleClass]="styleClass"
  (click)="buttonClicked.emit()"
  [rounded]="rounded"
/>
